export { default } from './CloudinaryImage'
